import { ImageEnrichment } from '@sprinklr/stories/post/Post';
import { meanPlacement } from 'utils/MathUtils/LinearMeasurement';

export const getBackgroundOffset = (enrichment: ImageEnrichment) => {
    if (enrichment) {
        const { faces, height, width } = enrichment;
        const imageOffsetX: number =
            meanPlacement(width, [faces.boundingBox.x0, faces.boundingBox.x1]) * 100;
        const imageOffsetY: number =
            meanPlacement(height, [faces.boundingBox.y0, faces.boundingBox.y1]) * 100;
        return `${imageOffsetX}% ${imageOffsetY}%`;
    } else {
        return 'center center';
    }
};
export const getImageUrl = images => {
    if (images?.[0]?.url) {
        return images[0].url;
    } else if (images?.[0]?.picture) {
        return images[0].picture;
    }
};
export const getEnrichment = images => {
    return images?.[0]?.enrichment;
};

export const getVideoUrl = videos => {
    return videos?.[0]?.url;
};

export const getVideoUrlPoster = videos => {
    return videos?.[0]?.poster;
};
export const hasMedia = (images, videos): boolean => {
    return !!getImageUrl(images) || !!getVideoUrl(videos) || !!getVideoUrlPoster(videos);
};
